import React, { useEffect } from 'react';
import i18n from './i18n';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

export function I18nProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (!i18n.isInitialized) {
      const storedLang = localStorage.getItem('i18nextLng');
      const browserLang = storedLang || navigator.language || navigator.languages?.[0] || 'fr';
      const supported = ['fr', 'en'];
      const shortLang = browserLang.split('-')[0];
      const initialLang = supported.includes(shortLang) ? shortLang : 'fr';

      i18n
        .use(HttpBackend)
        .use(initReactI18next)
        .init({
          lng: initialLang,
          fallbackLng: 'fr',
          supportedLngs: ['fr', 'en'],
          keySeparator: '.',
          debug: import.meta.env.DEV,
          backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
          },
          // React échappe déjà le rendu : l'échappement i18next produirait `&#x2F;` dans les dates
          interpolation: { escapeValue: false },
          ns: ['translation', 'brl'],
          defaultNS: 'translation'
        });
    }
  }, []);

  return <>{children}</>;
}
